// extracted by mini-css-extract-plugin
module.exports = {"download":"Download_download__-wimC","loading":"Download_loading__16vo1","fadeIn":"Download_fadeIn__2W-UA","scaleXin":"Download_scaleXin__1X2UN"};